export default __webpack_public_path__ + "static/media/Panda.e39a1ef5.png";